export class PedidoCancelamento {
    id: number;
    idMotivoCancelado: number;
    motivo: string;

    constructor(id: number) {
        this.id = id;
    }
}
